import React, { useState, useContext } from "react";
import { Form, Input, Button, Modal } from 'antd';
import { useHistory, Link } from "react-router-dom";
import { saveNewAccount } from "../../actions"
import { StoreContext } from "../../store";

export default function AddAccountCard() {
  const { state: { accountDetail:{ newAccount}, userSignin: {userInfo}}, dispatch } = useContext(StoreContext);
    const [form] = Form.useForm();
    const history = useHistory();
    const AddAccountCheck = (values) => {
      console.log('AddAccountCheck Received values of form: ', values);
      if(!values.account_admin)
        values.account_admin = false;
      Object.keys(values).forEach(function(key, index) {
        if (this[key] == null) this[key] = "";
      }, values);  
      saveNewAccount(dispatch, values)
      history.push("/addaccountcheck");
    };
    
    const [isModalVisible, setIsModalVisible] = useState(false);
    const showModal = () => {
      setIsModalVisible(true);
    };
    
    const handleOk = () => {
      history.push("/accountmag");
      setIsModalVisible(false);
      saveNewAccount(dispatch, "");
    };
    
    const handleCancel = () => {
      setIsModalVisible(false);
    };

  return (
    <div className="main-layout">
      <div className="addcustomer-wrapper">
        <img src="/images/ad_2_img.png" className="add_pic"/>
        <img src="/images/back_btn.png" className="back_btn" onClick={showModal}/>
        <Modal title="NEXMOW management system" visible={isModalVisible}
          onOk={handleOk} onCancel={handleCancel}>
          <p>Are you sure to exit without save?</p>
        </Modal>
      </div>
      <div className="addcustomer-form">
        <div className="addcustomer">
            <p className="addcustomer-title">Add new account</p> 
            <hr className="hr-addcustomerline" />
        </div>
        <Form
          className="accountform_list"
          name="add_account_form"
          form={form}
          layout="vertical"
          initialValues={newAccount}
          onFinish={AddAccountCheck}
        >
        <Form.Item 
          label="Account Name" required 
          name="account_name"
          className="addcustomer_form"
          rules={[
            ({getFieldValue})=>({
              validator(rule,value){
                var compRegxp = /(^\s)|(\s$)/;
                var charRegxp = /(\w+)/;
                if(value && !compRegxp.test(value) && charRegxp.test(value)){
                  return Promise.resolve()
                }
                if(value && compRegxp.test(value)){
                  return Promise.reject("No space in the front/back");
                }
                if(value && !compRegxp.test(value)){
                  return Promise.reject("Require at least 1 characters");
                }
              }
            }),
            {
              required: true,
              message: "Please input name",
            },
          ]}
          hasFeedback
          >
            <Input placeholder="input placeholder" />
        </Form.Item>
        <Form.Item 
          label="Email address" required 
          name="account_email"
          className="addcustomer_form"
          rules={[
            ({getFieldValue})=>({
              validator(rule,value){
                var emailRegxp = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
                if(value && emailRegxp.test(value)){
                  return Promise.resolve()
                }
                return Promise.reject("Incorrect email")
              }
            }),
            {
              type: "string",
              required: true,
              message: "Please input email address",
            }
          ]}
          hasFeedback
          >
            <Input placeholder="input placeholder" />
        </Form.Item>
        <Form.Item 
          label="Password" required 
          name="account_password"
          className="addcustomer_form"
          rules={[
            {
              required: true,
              message: "Please input password",
            },
            { min: 6, message: 'Username must be minimum 6 characters.' },
          ]}
          hasFeedback
          >
            <Input placeholder="input placeholder" />
        </Form.Item>
        <Form.Item 
          label="Retype password" required 
          name="account_password_check"
          className="addcustomer_form"
          rules={[
            ({getFieldValue})=>({
                validator(rule,value){
                  if(!value || getFieldValue('account_password') === value){
                    return Promise.resolve()
                  }
                    return Promise.reject("Incorrect password")
                  }              
                }),            
                {
                required: true,
                message: "Please input password again",
            },
          ]}
          hasFeedback
          >
            <Input placeholder="input placeholder" />
        </Form.Item>
        <Form.Item
            label="Job title (optional)"
            name="account_job"
            className="addcustomer_form"
            hasFeedback
            >
            <Input placeholder="input placeholder" />
        </Form.Item>
        <Form.Item
          label="Phone number (optional)"
          name="account_phone"
          className="addcustomer_form"
          hasFeedback
          >
            <Input placeholder="input placeholder" />
        </Form.Item>
        <Form.Item
          label="zip (optional)"
          name="account_zip"
          className="addcustomer_form"
          hasFeedback
          >
            <Input placeholder="input placeholder" />
        </Form.Item>
        <Form.Item
          label="address (optional)"
          name="account_address"
          className="addcustomer_form"
          hasFeedback
          >
            <Input placeholder="input placeholder" />
        </Form.Item>
        <Form.Item
          label="Adminsitrator?"
          name="account_admin"
          valuePropName="checked"
          className="addcustomer_form"
          hasFeedback
        >
        <input type="checkbox" value="admin"/>
        </Form.Item>
        <Form.Item className="login-enter">
          <Button
            htmlType="submit"
            className="addcustomer_btn"
          >
            Save
          </Button>
        </Form.Item>
        </Form>
      </div>
    </div>
  );
};